import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Configurations } from './configuration';
import { MapComponent } from './map.component';
import { GMapComponent } from './google/gmap.component';
import { HMapComponent } from './here/hmap.component';
import { MapSearchComponent } from './map-search/map-search.component';
import { GMapSearchComponent } from './google/gmap-search.component';
import { HMapSearchComponent } from './here/hmap-search.component';

@NgModule({
  declarations: [MapComponent, MapSearchComponent, GMapComponent, HMapComponent,
    GMapSearchComponent, HMapSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
  ],
  exports: [
    MapComponent, MapSearchComponent
  ]
})
export class MapModule {
  public static forRoot(config: Configurations): ModuleWithProviders<MapModule> {
    return {
      ngModule: MapModule,
      providers: [
        { provide: Configurations, useValue: config }
      ]
    };
  }
}
